import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Handles drag-to-reorder of segments in the timeline strip.
// Sends PATCH to the reorder_segment endpoint with target_index.
export default class extends Controller {
  static targets = ["list", "status"]
  static values = {
    configId: Number,
    reorderUrlTemplate: String,  // e.g. "/slideshow_configs/123/segments/__INDEX__/reorder"
    queryParam: { type: String, default: "segment" }  // e.g. "block" for educational configs
  }

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: "[data-segment-drag-handle]",
      animation: 150,
      ghostClass: "opacity-30",
      dragClass: "shadow-lg",
      direction: "horizontal",
      onEnd: this.onDragEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onDragEnd(event) {
    const { oldIndex, newIndex } = event
    if (oldIndex === newIndex) return

    this.updateStatus("Saving...")

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const url = this.reorderUrlTemplateValue.replace("__INDEX__", oldIndex)

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ target_index: newIndex })
      })

      if (response.ok) {
        this.updateStatus("")
        // Reload to get updated indices and selected state
        window.location.href = window.location.pathname + `?${this.queryParamValue}=${newIndex}`
      } else {
        this.revertOrder(event)
        const data = await response.json().catch(() => ({}))
        this.updateStatus(`Error: ${data.error || "Failed to reorder"}`)
      }
    } catch (error) {
      console.error("Segment reorder failed:", error)
      this.revertOrder(event)
      this.updateStatus("Reorder failed")
    }
  }

  revertOrder(event) {
    const { oldIndex, newIndex } = event
    const parent = this.listTarget
    const children = Array.from(parent.children)
    const movedEl = children[newIndex]

    parent.removeChild(movedEl)

    if (oldIndex >= parent.children.length) {
      parent.appendChild(movedEl)
    } else {
      parent.insertBefore(movedEl, parent.children[oldIndex])
    }
  }

  updateStatus(text) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = text
    }
  }
}
